import { styled } from '@mui/system'
import Button from '../../molecules/button'
import BHPagination from '../../molecules/pagination'
import BHBreadcrumbs from '../../organisms/breadcrumbs'
import Typography from '../../atoms/typography'

const shouldForwardProp = (prop) => !['viewMode'].includes(prop)

export const BlogWrapper = styled('div')`
	position: relative;
`

export const Heading = styled(Typography)`
	padding: ${({ theme }) => theme.spacing(2, 2)};
	${({ theme }) => theme.breakpoints.up('md')} {
		padding: ${({ theme }) => theme.spacing(2, 5)};
	}
`

export const Breadcrumbs = styled(BHBreadcrumbs)`
	display: none;
	${({ theme }) => theme.breakpoints.up('md')} {
		display: block;
		padding: ${({ theme }) => theme.spacing(2, 5)};
	}
`

export const Content = styled('div', { shouldForwardProp })`
	position: relative;
	width: 100%;
	padding: ${({ theme, viewMode }) => (viewMode === 'masonry' ? theme.spacing(4, 0, 0, 2) : theme.spacing(4, 2))};
	margin-top: ${({ theme }) => theme.spacing(2)};
	${({ theme }) => theme.breakpoints.up('md')} {
		padding: ${({ theme, viewMode }) => (viewMode === 'masonry' ? theme.spacing(4, 0, 0, 2) : theme.spacing(4, 5))};
	}
	.BlogItems-Root {
		&.masonry {
			/*  manage x-axis overflow */
			max-width: calc(100vw - var(--scrollBarWidth));
			overflow-x: hidden;
			${({ theme }) => theme.breakpoints.up('md')} {
				--scrollBarWidth: var(--global-scrollbar-width, 0px);
			}
		}
	}
`

export const RootFilters = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	padding: ${({ theme }) => theme.spacing(4, 4, 0)};
	${({ theme }) => theme.breakpoints.up('md')} {
		padding: ${({ theme }) => theme.spacing(4, 5, 0)};
	}
`

export const Filter = styled(Button)`
	margin: ${({ theme }) => theme.spacing(1, 2)};
	&:not(.active) {
		border-bottom: 0;
	}
`
export const Pagination = styled(BHPagination)`
	ul {
		justify-content: center;
	}
`
